// React imports.
import React, { Component } from "react";

//library imports
import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting'; 
import offlineExporting from 'highcharts/modules/offline-exporting';
import HighchartsReact from 'highcharts-react-official';
import highchartsMap from "highcharts/modules/map";
//import proj4 from "proj4";
import mapDataUS from "@highcharts/map-collection/countries/us/us-all.geo.json";

// Initialize the exporting module
exporting(Highcharts);
offlineExporting(Highcharts);


highchartsMap(Highcharts); // Initialize the map module

//if (typeof window !== "undefined") {
//  window.proj4 = window.proj4 || proj4;
//}

const ChartMap = ({ title, subTitle, seriesData}) => {

  let options = {
    exporting: {
      buttons: {
          contextButton: {
              menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
          }
      }
    },
    chart: {
      borderWidth: 1
    },
    title: {
      text: title
    },
    subtitle: {
      text: subTitle
    },
    legend: {
      layout: 'horizontal',
      borderWidth: 0,
      backgroundColor: 'rgba(255,255,255,0.85)',
      floating: true,
      verticalAlign: 'bottom',
      align: 'left',
    },
    credits: {
      text: 'LIHEAP Performance Measurement Website ',
      href: 'liheappm.ncat.org'
    },
    mapNavigation: {
      enabled: true
    },
    colorAxis: {
      min: 1,
      type: 'linear',
      minColor: '#EEEEFF',
      maxColor: '#000022',
      stops: [
        [0, '#fef0d9'],
        [0.67, '#fc8d59'],
        [1, '#d7301f']
      ]
    },
    series: [{
      animation: {
        duration: 1000
      },
      data: seriesData,
      mapData: mapDataUS,
      joinBy: ['postal-code', 'code'],
      dataLabels: {
        enabled: true,
        color: 'black',
        format: '{point.code}'
      },
      name: ' ',
      tooltip: {
        headerFormat: '',
        pointFormat: '{point.name}: {point.displayVal}',
        footerFormat: '',
        shared: true,
        useHTML: true
      }

    }]
  };
  return (
    <HighchartsReact constructorType={'mapChart'} highcharts={Highcharts} options={options} />
  );
}
export default ChartMap;
